module.exports = __webpack_public_path__ + "img/mapa.dbba15a0.png";